import { fetchAndSetDeals } from 'components/views/FounderDeals/_helpers/founderDeals.resolvers';
import { $form, $list, $view } from 'signals/global.signals';
import displayNotification from 'utils/displayNotification';
import displayError from 'utils/displayError';
import { createDeal, deleteDeal, updateDeal } from 'api/deals.api';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import getSelectValue from 'utils/getSelectValue';

export const handleSubmitCreateDeal = async () => {
  $view.update({
    isModalLoading: true,
  });
  const formData = {
    name: $form.value.name,
    investmentStage: getSelectValue($form.value.investmentStage),
    typeOfRaise: getSelectValue($form.value.investmentStage) === 'Acquisition' ? 'Acquisition' : getSelectValue($form.value.typeOfRaise),
    currentValue: $form.value.currentValue,
    currentRaiseSize: $form.value.currentRaiseSize,
    amountCommitted: $form.value.amountCommitted,
    minimumInvestment: $form.value.minimumInvestment,
    fundingDate: $form.value.fundingDate,
    usesOfCapital: $form.value.usesOfCapital,
    preMoneyValuation: $form.value.preMoneyValuation,
    amountPreviouslyRaised: $form.value.amountPreviouslyRaised,
    valuationLastRound: $form.value.valuationLastRound,
    cap: $form.value.cap,
    discountPercent: $form.value.discountPercent,
    interestRate: $form.value.interestRate,
    dealTerms: $form.value.dealTerms,
  };
  try {
    await createDeal(formData);
    displayNotification({ message: 'Deal created successfully', title: 'Deal Created' });
    await fetchAndSetDeals();
    handleHideModal();
  } catch (error) {
    displayError({
      message: 'Failed to create deal. Please check your information and try again.',
      title: 'Deal Creation Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};

export const handleSubmitEditDeal = async () => {
  $view.update({
    isModalLoading: true,
  });

  const formData = {
    name: $form.value.name,
    investmentStage: getSelectValue($form.value.investmentStage),
    typeOfRaise: getSelectValue($form.value.typeOfRaise),
    currentValue: $form.value.currentValue,
    currentRaiseSize: $form.value.currentRaiseSize,
    amountCommitted: $form.value.amountCommitted,
    minimumInvestment: $form.value.minimumInvestment,
    fundingDate: $form.value.fundingDate,
    usesOfCapital: $form.value.usesOfCapital,
    preMoneyValuation: $form.value.preMoneyValuation,
    amountPreviouslyRaised: $form.value.amountPreviouslyRaised,
    valuationLastRound: $form.value.valuationLastRound,
    cap: $form.value.cap,
    discountPercent: $form.value.discountPercent,
    interestRate: $form.value.interestRate,
    dealTerms: $form.value.dealTerms,
  };
  try {
    await updateDeal($form.value.id, formData);
    displayNotification({ message: 'Deal updated successfully', title: 'Deal Updated' });
    await fetchAndSetDeals();
    handleHideModal();
  } catch (error) {
    displayError({
      message: 'Failed to update deal. Please check your information and try again.',
      title: 'Deal Update Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};

export const handleChangeSearch = (e) => {
  const { name, value } = e.target;
  $form.update({ [name]: value });
  const data = $list.value.originalData.filter((deal) => {
    const dealName = deal.name || `Untitled Deal - ${deal.id}`;
    return dealName.toLowerCase().includes(value.toLowerCase());
  });

  $list.update({ data });
};

export const handleSubmitDealDeleteSubmit = async (dealId) => {
  $view.update({ isModalLoading: true });
  try {
    await deleteDeal(dealId);
    displayNotification({ message: 'Deal deleted successfully', title: 'Deal Deleted' });
  } catch (error) {
    displayError({
      message: 'Failed to delete deal. Please try again.',
      title: 'Deal Deletion Error',
    });
  } finally {
    await fetchAndSetDeals();
    handleHideModal();
    $view.update({ isModalLoading: false });
  }
};
